import { IBusiness } from "@/business/business";

export const getTenantSelectableBusinesses = <
  TBusiness extends Pick<IBusiness, "churned_at">,
>(
  businesses: TBusiness[],
) => businesses.filter((business) => business.churned_at === null);

export const getValidTenantBusinessId = <
  TBusiness extends Pick<IBusiness, "id">,
>(
  businesses: TBusiness[],
  selectedBusinessId: string | null,
) =>
  businesses.some((business) => business.id === selectedBusinessId)
    ? selectedBusinessId
    : (businesses[0]?.id ?? null);
